import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import Layout from '@/layout';
export default {
  path: '/baseInfoService',
  component: Layout,
  redirect: '/baseInfoService/hospitalAdmin',
  name: 'baseInfoService',
  meta: {
    title: '基础信息管理',
    icon: 'jichu'
  },
  hidden: false,
  children: [{
    path: 'staffAdmin',
    component: function component() {
      return import('@/views/baseInfoService/staffAdmin/index.vue');
    },
    name: 'staffAdmin',
    meta: {
      title: '员工管理'
    },
    hidden: false
  }, {
    path: 'keshiAdmin',
    component: function component() {
      return import('@/views/baseInfoService/keshiAdmin/index.vue');
    },
    name: 'keshiAdmin',
    meta: {
      title: '科室管理'
    },
    hidden: false
  }, {
    path: 'positionAdmin',
    component: function component() {
      return import('@/views/baseInfoService/positionAdmin/index.vue');
    },
    name: 'positionAdmin',
    meta: {
      title: '职位管理'
    },
    hidden: false
  }
  //  {
  //   path: 'hospitalAdmin',
  //   component: () => import('@/views/baseInfoService/hospitalAdmin/index.vue'),
  //   name: 'hospitalAdmin',
  //   meta: {
  //     title: '医院信息维护',
  //   },

  //   hidden: false
  // }, {
  //   path: 'protocolManagement',
  //   component: () => import('@/views/baseInfoService/protocolManagement/index.vue'),
  //   name: 'protocolManagement',
  //   meta: {
  //     title: '协议信息维护',
  //   },
  //   hidden: false
  // }
  ]
};